export const bikeTheftMapDataByYear = {
  2019: {
    Bikes: [{
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 0,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 1,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 2,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 3,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 2,
      key: 4,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 2,
      key: 5,
    },
    {
      Location: 'Campus',
      center: [37.8843444, -122.2524965],
      count: 2,
      key: 6,
    },
    {
      Location: 'Campus',
      center: [37.8843444, -122.2524965],
      count: 2,
      key: 7,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 1,
      key: 8,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 1,
      key: 9,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 1,
      key: 10,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 1,
      key: 11,
    },
    {
      Location: 'Edwards Stadium',
      center: [37.8689946, -122.2648373],
      count: 2,
      key: 12,
    },
    {
      Location: 'Edwards Stadium',
      center: [37.8689946, -122.2648373],
      count: 2,
      key: 13,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 14,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 15,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 16,
    },
    {
      Location: 'Foothill-3',
      center: [37.87545950000001, -122.2561375],
      count: 1,
      key: 17,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 1,
      key: 18,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 2,
      key: 19,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 2,
      key: 20,
    },
    {
      Location: 'Li Ka Shing',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 21,
    },
    {
      Location: 'Li Ka Shing',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 22,
    },
    {
      Location: 'Manville Apts',
      center: [37.865799, -122.266847],
      count: 1,
      key: 23,
    },
    {
      Location: 'Manville Apts Lot',
      center: [37.865799, -122.266847],
      count: 2,
      key: 24,
    },
    {
      Location: 'Manville Apts Lot',
      center: [37.865799, -122.266847],
      count: 2,
      key: 25,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 26,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 27,
    },
    {
      Location: 'Mccone Hall',
      center: [37.8740817, -122.2596788],
      count: 1,
      key: 28,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 1,
      key: 29,
    },
    {
      Location: 'Northgate Hall',
      center: [37.8749998, -122.2596684],
      count: 1,
      key: 30,
    },
    {
      Location: 'Ucpd',
      center: [37.86924080000001, -122.2586773],
      count: 1,
      key: 31,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 2,
      key: 32,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 2,
      key: 33,
    },
    {
      Location: 'Wellman Courtyard',
      center: [37.8734236, -122.2628765],
      count: 1,
      key: 34,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 35,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 36,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 37,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 38,
    },
    {
      Location: '1000 6th St',
      center: [37.8826301, -122.3026462],
      count: 1,
      key: 39,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 1,
      key: 40,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 41,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 42,
    },
    {
      Location: '2199 Addison St',
      center: [37.8718509, -122.2665235],
      count: 1,
      key: 43,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 4,
      key: 44,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 4,
      key: 45,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 4,
      key: 46,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 4,
      key: 47,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 48,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 49,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 50,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 51,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 52,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 53,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 54,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 55,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 56,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 57,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 58,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 59,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 13,
      key: 60,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 61,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 62,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 63,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 64,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 65,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 66,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 67,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 68,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 69,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 70,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 7,
      key: 71,
    },
    {
      Location: '2610 Channing Wy',
      center: [37.8670799, -122.2556761],
      count: 1,
      key: 72,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 73,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 74,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 75,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 76,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 77,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 78,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 7,
      key: 79,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 80,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 81,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 82,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 83,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 84,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 85,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 86,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 87,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 88,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 89,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 11,
      key: 90,
    },
    {
      Location: '600 RED OAK',
      center: [37.8820656, -122.2817154],
      count: 1,
      key: 91,
    },
    {
      Location: '670 Kula Gulf Wy',
      center: [37.8839122, -122.3038643],
      count: 1,
      key: 92,
    },
    {
      Location: 'Shattuck Av & Hearst Av',
      center: [37.873882, -122.268585],
      count: 1,
      key: 93,
    }],
    'E-Bikes': [{
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 1,
      key: 94,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 1,
      key: 95,
    },
    {
      Location: 'Parking Lot,',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 96,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 1,
      key: 97,
    },
    {
      Location: '2227 Piedmont Av',
      center: [37.8711347, -122.2508543],
      count: 1,
      key: 98,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 1,
      key: 99,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 1,
      key: 100,
    }],
    'E-Scooters': [{
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 1,
      key: 101,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 1,
      key: 102,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 1,
      key: 103,
    }],
  },
  2020: {
    Bikes: [{
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 104,
    },
    {
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 105,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 106,
    },
    {
      Location: 'I House',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 107,
    },
    {
      Location: 'Life Science Addition',
      center: [37.8720856, -122.2632984],
      count: 2,
      key: 108,
    },
    {
      Location: 'Life Science Addition',
      center: [37.8720856, -122.2632984],
      count: 2,
      key: 109,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 110,
    },
    {
      Location: 'Manville Apts',
      center: [37.865799, -122.266847],
      count: 1,
      key: 111,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 1,
      key: 112,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 1,
      key: 113,
    },
    {
      Location: 'Upper Sproul Pz',
      center: [37.8695385, -122.2593363],
      count: 1,
      key: 114,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 3,
      key: 115,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 3,
      key: 116,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 3,
      key: 117,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 118,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 119,
    },
    {
      Location: '1005 6TH',
      center: [37.8827186, -122.3021147],
      count: 1,
      key: 120,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 1,
      key: 121,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 2,
      key: 122,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 2,
      key: 123,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 124,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 125,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 126,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 2,
      key: 127,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 2,
      key: 128,
    },
    {
      Location: '2441 Haste St',
      center: [37.86618139999999, -122.259141],
      count: 1,
      key: 129,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 3,
      key: 130,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 3,
      key: 131,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 3,
      key: 132,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 133,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 134,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 135,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 1,
      key: 136,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 1,
      key: 137,
    },
    {
      Location: '425 Liberty Ship Wy',
      center: [37.8843463, -122.3043294],
      count: 1,
      key: 138,
    },
    {
      Location: '515 West End Wy',
      center: [37.8840618, -122.3047723],
      count: 1,
      key: 139,
    },
    {
      Location: '525 Red Oak Av',
      center: [37.8831357, -122.3032233],
      count: 1,
      key: 140,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 1,
      key: 141,
    },
    {
      Location: '660 Kinkead Wy',
      center: [37.8839623, -122.302912],
      count: 2,
      key: 142,
    },
    {
      Location: '660 Kinkead Wy',
      center: [37.8839623, -122.302912],
      count: 2,
      key: 143,
    },
    {
      Location: '675 Kula Gulf Wy',
      center: [37.8840143, -122.3032885],
      count: 1,
      key: 144,
    },
    {
      Location: '805 Kinkead Wy',
      center: [37.8837672, -122.3018489],
      count: 1,
      key: 145,
    },
    {
      Location: 'Moffitt Library,',
      center: [37.8725327, -122.2608366],
      count: 1,
      key: 146,
    },
    {
      Location: 'Uva-153,   Uva 202',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 147,
    },
    {
      Location: 'Uva-169,   Uva 203',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 148,
    }],
    'E-Bikes': [{
      Location: 'I House Lot',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 149,
    },
    {
      Location: 'Kroeber Pz',
      center: [37.8693333, -122.2551512],
      count: 1,
      key: 150,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 151,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 152,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 1,
      key: 153,
    },
    {
      Location: '405 Red Oak Ave',
      center: [37.8833256, -122.3040229],
      count: 1,
      key: 154,
    }],
    'E-Scooters': [{
      Location: 'Southwest Corner Bicycle Racks',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 155,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 1,
      key: 156,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 157,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 158,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 1,
      key: 159,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 1,
      key: 160,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 1,
      key: 161,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 1,
      key: 162,
    },
    {
      Location: '400 Ohlone Av',
      center: [37.88462020000001, -122.3042851],
      count: 1,
      key: 163,
    }],
  },
  2021: {
    Bikes: [{
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 2,
      key: 164,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 2,
      key: 165,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 1,
      key: 166,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 1,
      key: 167,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 1,
      key: 168,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 1,
      key: 169,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 1,
      key: 170,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 2,
      key: 171,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 2,
      key: 172,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 1,
      key: 173,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 1,
      key: 174,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 1,
      key: 175,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 2,
      key: 176,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 2,
      key: 177,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 178,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 179,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 180,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 181,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 1,
      key: 182,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 3,
      key: 183,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 3,
      key: 184,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 3,
      key: 185,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 186,
    },
    {
      Location: 'Peoples Park',
      center: [37.86576489999999, -122.2570668],
      count: 1,
      key: 187,
    },
    {
      Location: 'Spieker Pz',
      center: [37.8699765, -122.2618077],
      count: 2,
      key: 188,
    },
    {
      Location: 'Spieker Pz',
      center: [37.8699765, -122.2618077],
      count: 2,
      key: 189,
    },
    {
      Location: 'UCPD',
      center: [37.86924080000001, -122.2586773],
      count: 1,
      key: 190,
    },
    {
      Location: 'Upper Sproul Pz',
      center: [37.8695385, -122.2593363],
      count: 1,
      key: 191,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 1,
      key: 192,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 1,
      key: 193,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 194,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 195,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 196,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 197,
    },
    {
      Location: '1000 Sixth St',
      center: [37.8826301, -122.3026462],
      count: 1,
      key: 198,
    },
    {
      Location: '1110 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 2,
      key: 199,
    },
    {
      Location: '1110 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 2,
      key: 200,
    },
    {
      Location: '1601 Allston Wy',
      center: [37.8682939, -122.2785699],
      count: 1,
      key: 201,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 1,
      key: 202,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 3,
      key: 203,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 3,
      key: 204,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 3,
      key: 205,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 206,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 207,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 208,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 209,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 210,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 6,
      key: 211,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 212,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 213,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 214,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 215,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 1,
      key: 216,
    },
    {
      Location: '2441 Haste St',
      center: [37.86618139999999, -122.259141],
      count: 1,
      key: 217,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 4,
      key: 218,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 4,
      key: 219,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 4,
      key: 220,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 4,
      key: 221,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 1,
      key: 222,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 223,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 224,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 225,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 226,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 227,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 5,
      key: 228,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 5,
      key: 229,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 5,
      key: 230,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 5,
      key: 231,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 5,
      key: 232,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 1,
      key: 233,
    },
    {
      Location: '400 Ohlone Av',
      center: [37.88462020000001, -122.3042851],
      count: 1,
      key: 234,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 1,
      key: 235,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 2,
      key: 236,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 2,
      key: 237,
    },
    {
      Location: '735 Gooding Wy',
      center: [37.8841952, -122.3012486],
      count: 1,
      key: 238,
    },
    {
      Location: '755 Ohlone Av',
      center: [37.8856183, -122.3021811],
      count: 1,
      key: 239,
    },
    {
      Location: '805 Kinkead Wy',
      center: [37.8837672, -122.3018489],
      count: 1,
      key: 240,
    },
    {
      Location: '945 Ohlone Av',
      center: [37.8856374, -122.3010868],
      count: 1,
      key: 241,
    },
    {
      Location: '980 Ohlone Av',
      center: [37.8855064, -122.300701],
      count: 1,
      key: 242,
    },
    {
      Location: 'KULA GULF/RED OAK,',
      center: [37.8841356, -122.3036352],
      count: 1,
      key: 243,
    },
    {
      Location: 'Uva-112,    305',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 244,
    }],
    'E-Bikes': [{
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 245,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 246,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 1,
      key: 247,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 1,
      key: 248,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 1,
      key: 249,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 250,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 251,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 3,
      key: 252,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 5,
      key: 253,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 5,
      key: 254,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 5,
      key: 255,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 5,
      key: 256,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 5,
      key: 257,
    },
    {
      Location: 'Tan Hall',
      center: [37.8732811, -122.256512],
      count: 1,
      key: 258,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 259,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 260,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 3,
      key: 261,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 3,
      key: 262,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 3,
      key: 263,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 3,
      key: 264,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 1,
      key: 265,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 1,
      key: 266,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 267,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 268,
    },
    {
      Location: 'BARKER HALL',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 269,
    }],
    'E-Scooters': [{
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 270,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 271,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 1,
      key: 272,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 273,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 274,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 1,
      key: 275,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 1,
      key: 276,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 3,
      key: 277,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 3,
      key: 278,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 3,
      key: 279,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 280,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 281,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 282,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 283,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 1,
      key: 284,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 285,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 1,
      key: 286,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 287,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 288,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 289,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 290,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 291,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 292,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 293,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 8,
      key: 294,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 1,
      key: 295,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 296,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 2,
      key: 297,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 2,
      key: 298,
    },
    {
      Location: '1898 Le Roy Av',
      center: [37.87533519999999, -122.2583139],
      count: 1,
      key: 299,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 1,
      key: 300,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 301,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 302,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 303,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 304,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 305,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 306,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 307,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 1,
      key: 308,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 1,
      key: 309,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 1,
      key: 310,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 311,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 312,
    },
    {
      Location: '685 Libertyship Wy',
      center: [37.8836726, -122.3041747],
      count: 1,
      key: 313,
    },
    {
      Location: 'BARKER HALL',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 314,
    }],
  },
  2022: {
    Bikes: [{
      Location: '',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 315,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 316,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 317,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 318,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 319,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 320,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 321,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 322,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 323,
    },
    {
      Location: 'Calvin Lab',
      center: [37.8709966, -122.2538012],
      count: 1,
      key: 324,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 3,
      key: 325,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 3,
      key: 326,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 3,
      key: 327,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 2,
      key: 328,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 2,
      key: 329,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 4,
      key: 330,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 4,
      key: 331,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 4,
      key: 332,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 4,
      key: 333,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 2,
      key: 334,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 2,
      key: 335,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 336,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 337,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 338,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 339,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 340,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 341,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 7,
      key: 342,
    },
    {
      Location: 'Genetics & Plant Biology Building',
      center: [37.8734399, -122.2673241],
      count: 1,
      key: 343,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 1,
      key: 344,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 1,
      key: 345,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 2,
      key: 346,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 2,
      key: 347,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 348,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 349,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 350,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 1,
      key: 351,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 3,
      key: 352,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 3,
      key: 353,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 3,
      key: 354,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 355,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 356,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 357,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 358,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 359,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 360,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 7,
      key: 361,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 1,
      key: 362,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 1,
      key: 363,
    },
    {
      Location: 'Peoples Park',
      center: [37.86576489999999, -122.2570668],
      count: 1,
      key: 364,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 365,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 366,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 367,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 368,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 369,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 370,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 1,
      key: 371,
    },
    {
      Location: 'Stern Hall',
      center: [37.8750175, -122.2555009],
      count: 1,
      key: 372,
    },
    {
      Location: 'University Village',
      center: [37.8848903, -122.3010578],
      count: 1,
      key: 373,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 1,
      key: 374,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 375,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 376,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 377,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 378,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 379,
    },
    {
      Location: '1005 Sixth St',
      center: [37.8827186, -122.3021147],
      count: 1,
      key: 380,
    },
    {
      Location: '1020 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 381,
    },
    {
      Location: '1893 Le Roy Av',
      center: [37.8754174, -122.2581251],
      count: 2,
      key: 382,
    },
    {
      Location: '1893 Le Roy Av',
      center: [37.8754174, -122.2581251],
      count: 2,
      key: 383,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 384,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 385,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 5,
      key: 386,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 5,
      key: 387,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 5,
      key: 388,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 5,
      key: 389,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 5,
      key: 390,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 391,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 392,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 393,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 394,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 395,
    },
    {
      Location: '2223 Fulton St',
      center: [37.8688308, -122.2654656],
      count: 1,
      key: 396,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 4,
      key: 397,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 4,
      key: 398,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 4,
      key: 399,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 4,
      key: 400,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 401,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 402,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 403,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 404,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 405,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 406,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 7,
      key: 407,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 1,
      key: 408,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 2,
      key: 409,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 2,
      key: 410,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 411,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 412,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 413,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 414,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 415,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 416,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 417,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 418,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 7,
      key: 419,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 420,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 421,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 422,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 423,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 424,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 6,
      key: 425,
    },
    {
      Location: '2645 Haste St',
      center: [37.8669775, -122.2549008],
      count: 1,
      key: 426,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 427,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 428,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 429,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 430,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 431,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 432,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 433,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 434,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 435,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 436,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 437,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 438,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 439,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 14,
      key: 440,
    },
    {
      Location: '300 Gooding Wy',
      center: [37.885189, -122.302004],
      count: 1,
      key: 441,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 1,
      key: 442,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 2,
      key: 443,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 2,
      key: 444,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 445,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 446,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 447,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 448,
    },
    {
      Location: '425 Liberty Ship Wy',
      center: [37.8843463, -122.3043294],
      count: 1,
      key: 449,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 450,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 451,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 2,
      key: 452,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 2,
      key: 453,
    },
    {
      Location: '515 West End Wy',
      center: [37.8840618, -122.3047723],
      count: 1,
      key: 454,
    },
    {
      Location: '525 Red Oak Av',
      center: [37.8831357, -122.3032233],
      count: 1,
      key: 455,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 456,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 457,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 458,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 459,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 460,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 2,
      key: 461,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 2,
      key: 462,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 1,
      key: 463,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 2,
      key: 464,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 2,
      key: 465,
    },
    {
      Location: '670 Kula Gulf Wy',
      center: [37.8839122, -122.3038643],
      count: 1,
      key: 466,
    },
    {
      Location: '685 Liberty Ship Wy',
      center: [37.8836726, -122.3041747],
      count: 1,
      key: 467,
    },
    {
      Location: '730 Kinkead Wy',
      center: [37.8836918, -122.3028234],
      count: 2,
      key: 468,
    },
    {
      Location: '730 Kinkead Wy',
      center: [37.8836918, -122.3028234],
      count: 2,
      key: 469,
    },
    {
      Location: '865 Kinkead Wy',
      center: [37.8835253, -122.3021704],
      count: 2,
      key: 470,
    },
    {
      Location: '865 Kinkead Wy',
      center: [37.8835253, -122.3021704],
      count: 2,
      key: 471,
    }],
    'E-Bikes': [{
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 472,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 473,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 474,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 1,
      key: 475,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 476,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 1,
      key: 477,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 478,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 479,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 3,
      key: 480,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 3,
      key: 481,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 3,
      key: 482,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 2,
      key: 483,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 2,
      key: 484,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 485,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 486,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 487,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 488,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 489,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 490,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 7,
      key: 491,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 492,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 493,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 494,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 495,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 496,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 497,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 498,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 499,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 9,
      key: 500,
    },
    {
      Location: 'Foothill-2',
      center: [37.8743687, -122.3044494],
      count: 1,
      key: 501,
    },
    {
      Location: 'Gilman Hall',
      center: [37.8726066, -122.2562309],
      count: 1,
      key: 502,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 1,
      key: 503,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 1,
      key: 504,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 1,
      key: 505,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 1,
      key: 506,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 507,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 508,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 509,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 1,
      key: 510,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 1,
      key: 511,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 1,
      key: 512,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 513,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 514,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 515,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 516,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 517,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 6,
      key: 518,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 519,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 520,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 521,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 4,
      key: 522,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 1,
      key: 523,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 2,
      key: 524,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 2,
      key: 525,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 526,
    },
    {
      Location: '1674 Shattuck Av',
      center: [37.877045, -122.2692766],
      count: 1,
      key: 527,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 1,
      key: 528,
    },
    {
      Location: '2214 Bancroft Wy',
      center: [37.8678762, -122.2645482],
      count: 1,
      key: 529,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 2,
      key: 530,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 2,
      key: 531,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 532,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 533,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 534,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 535,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 536,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 537,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 538,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 539,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 540,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 541,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 542,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 12,
      key: 543,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 544,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 545,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 3,
      key: 546,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 1,
      key: 547,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 1,
      key: 548,
    },
    {
      Location: '2610 Channing Wy',
      center: [37.8670799, -122.2556761],
      count: 1,
      key: 549,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 1,
      key: 550,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 1,
      key: 551,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 552,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 553,
    },
    {
      Location: '5325 Broder Blvd',
      center: [37.7182246, -121.8882794],
      count: 1,
      key: 554,
    },
    {
      Location: '580 Ohlone Av',
      center: [37.8848291, -122.3034214],
      count: 1,
      key: 555,
    },
    {
      Location: '755 Ohlone Av',
      center: [37.8856183, -122.3021811],
      count: 1,
      key: 556,
    }],
    'E-Scooters': [{
      Location: '',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 557,
    },
    {
      Location: '',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 558,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 559,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 560,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 561,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 562,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 563,
    },
    {
      Location: 'Bechtel Center',
      center: [37.8701625, -122.2692742],
      count: 1,
      key: 564,
    },
    {
      Location: 'California Hall',
      center: [37.8718862, -122.2603499],
      count: 1,
      key: 565,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 566,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 5,
      key: 567,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 5,
      key: 568,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 5,
      key: 569,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 5,
      key: 570,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 5,
      key: 571,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 572,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 573,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 574,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 575,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 576,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 6,
      key: 577,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 5,
      key: 578,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 5,
      key: 579,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 5,
      key: 580,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 5,
      key: 581,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 5,
      key: 582,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 2,
      key: 583,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 2,
      key: 584,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 1,
      key: 585,
    },
    {
      Location: 'Durant Hall',
      center: [37.8712498, -122.2600955],
      count: 1,
      key: 586,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 587,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 588,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 589,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 590,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 591,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 592,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 593,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 594,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 595,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 596,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 597,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 598,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 599,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 600,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 601,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 602,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 17,
      key: 603,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 2,
      key: 604,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 2,
      key: 605,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 606,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 607,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 608,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 609,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 610,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 611,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 612,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 613,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 614,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 615,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 616,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 617,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 618,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 619,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 620,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 621,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 622,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 18,
      key: 623,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 624,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 625,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 626,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 627,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 628,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 6,
      key: 629,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 630,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 631,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 632,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 633,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 634,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 6,
      key: 635,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 1,
      key: 636,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 2,
      key: 637,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 2,
      key: 638,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 639,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 640,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 641,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 642,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 643,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 644,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 645,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 646,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 647,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 648,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 11,
      key: 649,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 650,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 1,
      key: 651,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 1,
      key: 652,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 653,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 654,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 655,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 656,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 657,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 658,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 659,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 660,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 661,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 662,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 663,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 664,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 665,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 666,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 667,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 668,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 669,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 670,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 671,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 672,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 673,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 674,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 675,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 24,
      key: 676,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 3,
      key: 677,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 3,
      key: 678,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 3,
      key: 679,
    },
    {
      Location: 'Moses Hall',
      center: [37.8710156, -122.2580873],
      count: 1,
      key: 680,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 681,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 682,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 683,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 684,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 685,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 686,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 7,
      key: 687,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 1,
      key: 688,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 689,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 690,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 1,
      key: 691,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 2,
      key: 692,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 2,
      key: 693,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 694,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 695,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 696,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 697,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 1,
      key: 698,
    },
    {
      Location: 'Stern Hall',
      center: [37.8750175, -122.2555009],
      count: 1,
      key: 699,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 2,
      key: 700,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 2,
      key: 701,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 702,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 703,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 704,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 705,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 706,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 707,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 708,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 709,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 9,
      key: 710,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 711,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 712,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 713,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 714,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 715,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 716,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 717,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 718,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 719,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 720,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 9,
      key: 721,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 722,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 723,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 724,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 725,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 726,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 727,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 2,
      key: 728,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 2,
      key: 729,
    },
    {
      Location: '2195 Hearst Av',
      center: [37.8743927, -122.2668799],
      count: 1,
      key: 730,
    },
    {
      Location: '2200 Gayley Rd',
      center: [37.8722334, -122.2537191],
      count: 1,
      key: 731,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 732,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 733,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 734,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 735,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 5,
      key: 736,
    },
    {
      Location: '2222 Bancroft Wy',
      center: [37.8676679, -122.2642858],
      count: 1,
      key: 737,
    },
    {
      Location: '2227 Piedmont Av',
      center: [37.8711347, -122.2508543],
      count: 1,
      key: 738,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 739,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 740,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 741,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 742,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 743,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 744,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 745,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 746,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 747,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 748,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 749,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 750,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 751,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 752,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 753,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 754,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 755,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 756,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 757,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 758,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 759,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 760,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 761,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 762,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 763,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 764,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 765,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 766,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 767,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 768,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 769,
    },
    {
      Location: '2400 Bancroft Wy',
      center: [37.8683734, -122.261079],
      count: 1,
      key: 770,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 771,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 772,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 773,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 774,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 775,
    },
    {
      Location: '2401 Durant Av',
      center: [37.8676699, -122.2611691],
      count: 1,
      key: 776,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 777,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 778,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 779,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 780,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 781,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 782,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 1,
      key: 783,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 784,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 785,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 2,
      key: 786,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 2,
      key: 787,
    },
    {
      Location: '2600 Ridge Rd',
      center: [37.8761356, -122.2579888],
      count: 1,
      key: 788,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 789,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 790,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 2,
      key: 791,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 2,
      key: 792,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 1,
      key: 793,
    },
    {
      Location: '3100 Adeline St',
      center: [37.85267899999999, -122.2698196],
      count: 1,
      key: 794,
    },
    {
      Location: '5325 Broder Blvd',
      center: [37.7182246, -121.8882794],
      count: 1,
      key: 795,
    },
    {
      Location: 'Bancroft Wy Dana St',
      center: [37.8685055, -122.2617699],
      count: 1,
      key: 796,
    },
    {
      Location: 'Bowditch St Durant Av',
      center: [37.8681013, -122.256738],
      count: 1,
      key: 797,
    },
    {
      Location: 'Claremont Av Russell St',
      center: [37.8590106, -122.2445519],
      count: 1,
      key: 798,
    },
    {
      Location: 'Piedmont Av',
      center: [37.8640777, -122.2514871],
      count: 1,
      key: 799,
    },
    {
      Location: 'SPIEKER PLAZA',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 800,
    },
    {
      Location: 'Shattuck Av Bancroft Wy',
      center: [37.8676154, -122.2677181],
      count: 1,
      key: 801,
    },
    {
      Location: 'Telegraph Av Bancroft Wy',
      center: [37.8687232, -122.2592109],
      count: 1,
      key: 802,
    }],
  },
  2023: {
    Bikes: [{
      Location: 'Anthropology & Art Practice Building',
      center: [37.869751, -122.25527],
      count: 1,
      key: 803,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 804,
    },
    {
      Location: 'Barrows Lane',
      center: [37.8645848, -122.2965778],
      count: 1,
      key: 805,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 806,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 807,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 808,
    },
    {
      Location: 'Calvin Lab',
      center: [37.8709966, -122.2538012],
      count: 1,
      key: 809,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 1,
      key: 810,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 4,
      key: 811,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 4,
      key: 812,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 4,
      key: 813,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 4,
      key: 814,
    },
    {
      Location: 'Hearst Memorial Gymnasium',
      center: [37.8695377, -122.256978],
      count: 1,
      key: 815,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 1,
      key: 816,
    },
    {
      Location: 'Hilgard Hall',
      center: [37.8733109, -122.2634045],
      count: 1,
      key: 817,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 818,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 819,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 820,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 2,
      key: 821,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 2,
      key: 822,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 1,
      key: 823,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 824,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 825,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 1,
      key: 826,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 1,
      key: 827,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 828,
    },
    {
      Location: 'University Village',
      center: [37.8848903, -122.3010578],
      count: 1,
      key: 829,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 1,
      key: 830,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 831,
    },
    {
      Location: '1070 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 832,
    },
    {
      Location: '1123 Jackson St',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 833,
    },
    {
      Location: '1301 S. 46th St',
      center: [37.9122458, -122.3338722],
      count: 2,
      key: 834,
    },
    {
      Location: '1301 S. 46th St',
      center: [37.9122458, -122.3338722],
      count: 2,
      key: 835,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 1,
      key: 836,
    },
    {
      Location: '2195 Hearst Av',
      center: [37.8743927, -122.2668799],
      count: 1,
      key: 837,
    },
    {
      Location: '2214 Bancroft Wy',
      center: [37.8678762, -122.2645482],
      count: 1,
      key: 838,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 1,
      key: 839,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 840,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 4,
      key: 841,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 4,
      key: 842,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 4,
      key: 843,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 4,
      key: 844,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 1,
      key: 845,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 846,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 847,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 848,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 849,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 5,
      key: 850,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 1,
      key: 851,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 3,
      key: 852,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 3,
      key: 853,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 3,
      key: 854,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 855,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 856,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 857,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 858,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 859,
    },
    {
      Location: '2684 Ridge Rd',
      center: [37.8762206, -122.2571975],
      count: 1,
      key: 860,
    },
    {
      Location: '3800 San Pablo Av',
      center: [37.8291644, -122.2788319],
      count: 1,
      key: 861,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 1,
      key: 862,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 1,
      key: 863,
    },
    {
      Location: '540 Red Oak Av',
      center: [37.8827229, -122.3031281],
      count: 1,
      key: 864,
    },
    {
      Location: 'Ohlone Av & Gooding Wy',
      center: [37.8851243, -122.3030119],
      count: 1,
      key: 865,
    },
    {
      Location: 'UVA-125,   UVA 755',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 866,
    }],
    'E-Bikes': [{
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 867,
    },
    {
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 868,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 869,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 870,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 3,
      key: 871,
    },
    {
      Location: 'Bechtel Center',
      center: [37.8701625, -122.2692742],
      count: 1,
      key: 872,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 1,
      key: 873,
    },
    {
      Location: 'Claremont Fire Tr',
      center: [37.871574, -122.2241913],
      count: 1,
      key: 874,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 1,
      key: 875,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 1,
      key: 876,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 5,
      key: 877,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 5,
      key: 878,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 5,
      key: 879,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 5,
      key: 880,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 5,
      key: 881,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 1,
      key: 882,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 883,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 884,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 885,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 4,
      key: 886,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 887,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 888,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 889,
    },
    {
      Location: 'Law Building Lot',
      center: [37.8699767, -122.2532914],
      count: 1,
      key: 890,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 2,
      key: 891,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 2,
      key: 892,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 2,
      key: 893,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 2,
      key: 894,
    },
    {
      Location: 'Moses Hall',
      center: [37.8710156, -122.2580873],
      count: 1,
      key: 895,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 896,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 897,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 898,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 899,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 1,
      key: 900,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 1,
      key: 901,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 1,
      key: 902,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 903,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 1,
      key: 904,
    },
    {
      Location: 'Starr East Asian Library',
      center: [37.8735757, -122.2599796],
      count: 1,
      key: 905,
    },
    {
      Location: 'Stephens Hall',
      center: [37.8713614, -122.2575925],
      count: 1,
      key: 906,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 907,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 908,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 909,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 910,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 911,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 912,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 7,
      key: 913,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 914,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 915,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 916,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 1,
      key: 917,
    },
    {
      Location: 'Zellerbach Hall',
      center: [37.86904570000001, -122.2606874],
      count: 1,
      key: 918,
    },
    {
      Location: '1108 8th Street',
      center: [37.8824687, -122.3000361],
      count: 1,
      key: 919,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 920,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 2,
      key: 921,
    },
    {
      Location: '2155 Center St',
      center: [37.8706773, -122.2662258],
      count: 1,
      key: 922,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 1,
      key: 923,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 924,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 5,
      key: 925,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 5,
      key: 926,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 5,
      key: 927,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 5,
      key: 928,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 5,
      key: 929,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 1,
      key: 930,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 1,
      key: 931,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 1,
      key: 932,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 1,
      key: 933,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 1,
      key: 934,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 1,
      key: 935,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 1,
      key: 936,
    },
    {
      Location: '945 Ohlone Av',
      center: [37.8856374, -122.3010868],
      count: 1,
      key: 937,
    },
    {
      Location: 'Harrison St 5TH STREET',
      center: [37.8809238, -122.3030285],
      count: 1,
      key: 938,
    }],
    'E-Scooters': [{
      Location: 'PPHCD',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 939,
    },
    {
      Location: 'Bancroft Wy',
      center: [37.8666995, -122.2747672],
      count: 1,
      key: 940,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 2,
      key: 941,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 2,
      key: 942,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 943,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 944,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 945,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 946,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 947,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 6,
      key: 948,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 949,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 950,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 951,
    },
    {
      Location: 'California Hall',
      center: [37.8718862, -122.2603499],
      count: 1,
      key: 952,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 953,
    },
    {
      Location: 'Campus (Unspecified Campus Location)',
      center: [37.8843444, -122.2524965],
      count: 1,
      key: 954,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 4,
      key: 955,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 4,
      key: 956,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 4,
      key: 957,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 4,
      key: 958,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 959,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 960,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 961,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 962,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 963,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 964,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 965,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 966,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 967,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 968,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 969,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 12,
      key: 970,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 971,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 972,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 973,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 974,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 975,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 6,
      key: 976,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 977,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 978,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 979,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 980,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 981,
    },
    {
      Location: 'Cyclotron Rd',
      center: [37.8746504, -122.2521967],
      count: 1,
      key: 982,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 2,
      key: 983,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 2,
      key: 984,
    },
    {
      Location: 'Dwinelle Annex',
      center: [37.8703395, -122.2612068],
      count: 1,
      key: 985,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 986,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 987,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 988,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 989,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 990,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 991,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 992,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 993,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 994,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 995,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 996,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 997,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 998,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 999,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 1000,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 1001,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 1002,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 1003,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 19,
      key: 1004,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 2,
      key: 1005,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 2,
      key: 1006,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1007,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1008,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1009,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1010,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1011,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1012,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1013,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1014,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1015,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1016,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1017,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1018,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1019,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1020,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1021,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1022,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1023,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1024,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1025,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1026,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1027,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1028,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1029,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1030,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1031,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1032,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 27,
      key: 1033,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 2,
      key: 1034,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 2,
      key: 1035,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 3,
      key: 1036,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 3,
      key: 1037,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 3,
      key: 1038,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 1,
      key: 1039,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 4,
      key: 1040,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 4,
      key: 1041,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 4,
      key: 1042,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 4,
      key: 1043,
    },
    {
      Location: 'Hertz Hall',
      center: [37.8710584, -122.2557289],
      count: 1,
      key: 1044,
    },
    {
      Location: 'Hesse Hall',
      center: [37.8743128, -122.2593508],
      count: 1,
      key: 1045,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 1,
      key: 1046,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 2,
      key: 1047,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 2,
      key: 1048,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 2,
      key: 1049,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 2,
      key: 1050,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1051,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1052,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1053,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1054,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1055,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1056,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 7,
      key: 1057,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 1058,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 1059,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 1060,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 3,
      key: 1061,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 3,
      key: 1062,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 3,
      key: 1063,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 2,
      key: 1064,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 2,
      key: 1065,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1066,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1067,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1068,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1069,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1070,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1071,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1072,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1073,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1074,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1075,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1076,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1077,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1078,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1079,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1080,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1081,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1082,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1083,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1084,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1085,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1086,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1087,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1088,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1089,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1090,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1091,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1092,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1093,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1094,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1095,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1096,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1097,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1098,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1099,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 35,
      key: 1100,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 1,
      key: 1101,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 1102,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 1103,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 1104,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 1105,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1106,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1107,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1108,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1109,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1110,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1111,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1112,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1113,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1114,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1115,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1116,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1117,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1118,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1119,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1120,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 8,
      key: 1121,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 1,
      key: 1122,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 5,
      key: 1123,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 5,
      key: 1124,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 5,
      key: 1125,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 5,
      key: 1126,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 5,
      key: 1127,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 2,
      key: 1128,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 2,
      key: 1129,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 1130,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 1131,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 1132,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 4,
      key: 1133,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 4,
      key: 1134,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 4,
      key: 1135,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 4,
      key: 1136,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 4,
      key: 1137,
    },
    {
      Location: 'Stanley Hall',
      center: [37.87385099999999, -122.2563984],
      count: 1,
      key: 1138,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 3,
      key: 1139,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 3,
      key: 1140,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 3,
      key: 1141,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1142,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1143,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1144,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1145,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1146,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1147,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1148,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1149,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1150,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 10,
      key: 1151,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 1,
      key: 1152,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1153,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1154,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1155,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1156,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1157,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1158,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1159,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1160,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1161,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1162,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1163,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 12,
      key: 1164,
    },
    {
      Location: 'Zellerbach Hall',
      center: [37.86904570000001, -122.2606874],
      count: 1,
      key: 1165,
    },
    {
      Location: '1070 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 1166,
    },
    {
      Location: '1898 Le Roy Av',
      center: [37.87533519999999, -122.2583139],
      count: 1,
      key: 1167,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1168,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1169,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1170,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 1,
      key: 1171,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1172,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1173,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1174,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1175,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1176,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1177,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 7,
      key: 1178,
    },
    {
      Location: '2222 Bancroft Wy',
      center: [37.8676679, -122.2642858],
      count: 1,
      key: 1179,
    },
    {
      Location: '2223 Fulton St',
      center: [37.8688308, -122.2654656],
      count: 1,
      key: 1180,
    },
    {
      Location: '2225 Piedmont Av',
      center: [37.87103949999999, -122.2526357],
      count: 1,
      key: 1181,
    },
    {
      Location: '2240 Piedmont Av',
      center: [37.8703966, -122.2528792],
      count: 2,
      key: 1182,
    },
    {
      Location: '2240 Piedmont Av',
      center: [37.8703966, -122.2528792],
      count: 2,
      key: 1183,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 1184,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1185,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1186,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1187,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1188,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1189,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1190,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1191,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1192,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1193,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1194,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1195,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1196,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1197,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1198,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1199,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1200,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1201,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1202,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1203,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1204,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1205,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1206,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1207,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1208,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1209,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1210,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1211,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1212,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1213,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 30,
      key: 1214,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 1,
      key: 1215,
    },
    {
      Location: '2369 Telegraph Av',
      center: [37.8674335, -122.2586978],
      count: 1,
      key: 1216,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1217,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1218,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1219,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1220,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1221,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1222,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1223,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 8,
      key: 1224,
    },
    {
      Location: '2401 Durant Av',
      center: [37.8676699, -122.2611691],
      count: 1,
      key: 1225,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1226,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1227,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1228,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1229,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1230,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 6,
      key: 1231,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 1232,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 1233,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 1234,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 1,
      key: 1235,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 1,
      key: 1236,
    },
    {
      Location: '2600 Ridge Rd',
      center: [37.8761356, -122.2579888],
      count: 1,
      key: 1237,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 4,
      key: 1238,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 4,
      key: 1239,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 4,
      key: 1240,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 4,
      key: 1241,
    },
    {
      Location: '2607 Hearst Av',
      center: [37.8757268, -122.2578584],
      count: 1,
      key: 1242,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 2,
      key: 1243,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 2,
      key: 1244,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 2,
      key: 1245,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 2,
      key: 1246,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 1247,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 1248,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 1249,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 1250,
    },
    {
      Location: 'Campanile Wy Dwinelle Path',
      center: [37.8714314, -122.2605093],
      count: 1,
      key: 1251,
    },
    {
      Location: 'Harrison St 5TH STREET',
      center: [37.8809238, -122.3030285],
      count: 1,
      key: 1252,
    },
    {
      Location: 'Hearst Av Spruce St',
      center: [37.8741496, -122.2655683],
      count: 1,
      key: 1253,
    },
    {
      Location: 'Piedmont Av',
      center: [37.8640777, -122.2514871],
      count: 1,
      key: 1254,
    },
    {
      Location: 'Piedmont Av Durant Av',
      center: [37.8686768, -122.2522753],
      count: 1,
      key: 1255,
    },
    {
      Location: 'Sports Ln South Street',
      center: [37.8646472, -122.2469543],
      count: 1,
      key: 1256,
    },
    {
      Location: 'Telegraph Av Channing Wy',
      center: [37.8669249, -122.2588171],
      count: 1,
      key: 1257,
    },
    {
      Location: 'University Av Oxford Ln',
      center: [37.8723917, -122.2661629],
      count: 1,
      key: 1258,
    }],
  },
  all: {
    Bikes: [{
      Location: '',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 1259,
    },
    {
      Location: 'Anthropology & Art Practice Building',
      center: [37.869751, -122.25527],
      count: 1,
      key: 1260,
    },
    {
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 1261,
    },
    {
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 1262,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 2,
      key: 1263,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 2,
      key: 1264,
    },
    {
      Location: 'Barrows Lane',
      center: [37.8645848, -122.2965778],
      count: 1,
      key: 1265,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1266,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1267,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1268,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1269,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1270,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1271,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1272,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1273,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1274,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1275,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 1276,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 1277,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 1278,
    },
    {
      Location: 'Boalt Hall',
      center: [37.8694764, -122.2540154],
      count: 4,
      key: 1279,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 4,
      key: 1280,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 4,
      key: 1281,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 4,
      key: 1282,
    },
    {
      Location: 'Bowles Hall',
      center: [37.87339960000001, -122.2530226],
      count: 4,
      key: 1283,
    },
    {
      Location: 'Calvin Lab',
      center: [37.8709966, -122.2538012],
      count: 2,
      key: 1284,
    },
    {
      Location: 'Calvin Lab',
      center: [37.8709966, -122.2538012],
      count: 2,
      key: 1285,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 1286,
    },
    {
      Location: 'Campus',
      center: [37.8843444, -122.2524965],
      count: 2,
      key: 1287,
    },
    {
      Location: 'Campus',
      center: [37.8843444, -122.2524965],
      count: 2,
      key: 1288,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 5,
      key: 1289,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 5,
      key: 1290,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 5,
      key: 1291,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 5,
      key: 1292,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 5,
      key: 1293,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1294,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1295,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1296,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1297,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 1298,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 1299,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 1300,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 1301,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 5,
      key: 1302,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 3,
      key: 1303,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 3,
      key: 1304,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 3,
      key: 1305,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1306,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1307,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1308,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1309,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1310,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 6,
      key: 1311,
    },
    {
      Location: 'Edwards Stadium',
      center: [37.8689946, -122.2648373],
      count: 2,
      key: 1312,
    },
    {
      Location: 'Edwards Stadium',
      center: [37.8689946, -122.2648373],
      count: 2,
      key: 1313,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1314,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1315,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1316,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1317,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1318,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1319,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1320,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1321,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1322,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1323,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 11,
      key: 1324,
    },
    {
      Location: 'Foothill-3',
      center: [37.87545950000001, -122.2561375],
      count: 1,
      key: 1325,
    },
    {
      Location: 'Genetics & Plant Biology Building',
      center: [37.8734399, -122.2673241],
      count: 1,
      key: 1326,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 2,
      key: 1327,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 2,
      key: 1328,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 2,
      key: 1329,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 2,
      key: 1330,
    },
    {
      Location: 'Hearst Memorial Gymnasium',
      center: [37.8695377, -122.256978],
      count: 1,
      key: 1331,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 2,
      key: 1332,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 2,
      key: 1333,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1334,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1335,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1336,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1337,
    },
    {
      Location: 'Hilgard Hall',
      center: [37.8733109, -122.2634045],
      count: 1,
      key: 1338,
    },
    {
      Location: 'I House',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 1339,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 1,
      key: 1340,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 1341,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 1342,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 3,
      key: 1343,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 3,
      key: 1344,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 3,
      key: 1345,
    },
    {
      Location: 'Leconte Hall',
      center: [37.8725655, -122.2572872],
      count: 3,
      key: 1346,
    },
    {
      Location: 'Li Ka Shing',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 1347,
    },
    {
      Location: 'Li Ka Shing',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 1348,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 1,
      key: 1349,
    },
    {
      Location: 'Life Science Addition',
      center: [37.8720856, -122.2632984],
      count: 2,
      key: 1350,
    },
    {
      Location: 'Life Science Addition',
      center: [37.8720856, -122.2632984],
      count: 2,
      key: 1351,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 1352,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 3,
      key: 1353,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 3,
      key: 1354,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 3,
      key: 1355,
    },
    {
      Location: 'Manville Apts',
      center: [37.865799, -122.266847],
      count: 2,
      key: 1356,
    },
    {
      Location: 'Manville Apts',
      center: [37.865799, -122.266847],
      count: 2,
      key: 1357,
    },
    {
      Location: 'Manville Apts Lot',
      center: [37.865799, -122.266847],
      count: 2,
      key: 1358,
    },
    {
      Location: 'Manville Apts Lot',
      center: [37.865799, -122.266847],
      count: 2,
      key: 1359,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1360,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1361,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1362,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1363,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1364,
    },
    {
      Location: 'Max Martinez',
      center: [37.8715226, -122.273042],
      count: 6,
      key: 1365,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1366,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1367,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1368,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1369,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1370,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 6,
      key: 1371,
    },
    {
      Location: 'Mccone Hall',
      center: [37.8740817, -122.2596788],
      count: 1,
      key: 1372,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1373,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1374,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1375,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1376,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1377,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1378,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1379,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1380,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1381,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1382,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1383,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1384,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1385,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 1,
      key: 1386,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 1387,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 1388,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 1389,
    },
    {
      Location: 'Northgate Hall',
      center: [37.8749998, -122.2596684],
      count: 1,
      key: 1390,
    },
    {
      Location: 'Peoples Park',
      center: [37.86576489999999, -122.2570668],
      count: 2,
      key: 1391,
    },
    {
      Location: 'Peoples Park',
      center: [37.86576489999999, -122.2570668],
      count: 2,
      key: 1392,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1393,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1394,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1395,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1396,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1397,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1398,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1399,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 8,
      key: 1400,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 1,
      key: 1401,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 1,
      key: 1402,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 1,
      key: 1403,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 1,
      key: 1404,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 1405,
    },
    {
      Location: 'Spieker Pz',
      center: [37.8699765, -122.2618077],
      count: 2,
      key: 1406,
    },
    {
      Location: 'Spieker Pz',
      center: [37.8699765, -122.2618077],
      count: 2,
      key: 1407,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 1,
      key: 1408,
    },
    {
      Location: 'Stern Hall',
      center: [37.8750175, -122.2555009],
      count: 1,
      key: 1409,
    },
    {
      Location: 'UCPD',
      center: [37.86924080000001, -122.2586773],
      count: 1,
      key: 1410,
    },
    {
      Location: 'Ucpd',
      center: [37.86924080000001, -122.2586773],
      count: 1,
      key: 1411,
    },
    {
      Location: 'University Village',
      center: [37.8848903, -122.3010578],
      count: 2,
      key: 1412,
    },
    {
      Location: 'University Village',
      center: [37.8848903, -122.3010578],
      count: 2,
      key: 1413,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 1,
      key: 1414,
    },
    {
      Location: 'Upper Sproul Pz',
      center: [37.8695385, -122.2593363],
      count: 2,
      key: 1415,
    },
    {
      Location: 'Upper Sproul Pz',
      center: [37.8695385, -122.2593363],
      count: 2,
      key: 1416,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 4,
      key: 1417,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 4,
      key: 1418,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 4,
      key: 1419,
    },
    {
      Location: 'Uva',
      center: [37.88365659999999, -122.3047727],
      count: 4,
      key: 1420,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 3,
      key: 1421,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 3,
      key: 1422,
    },
    {
      Location: 'Valley Life Science Bldg',
      center: [37.8714896, -122.2621408],
      count: 3,
      key: 1423,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 4,
      key: 1424,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 4,
      key: 1425,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 4,
      key: 1426,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 4,
      key: 1427,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 1428,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 2,
      key: 1429,
    },
    {
      Location: 'Wellman Courtyard',
      center: [37.8734236, -122.2628765],
      count: 1,
      key: 1430,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1431,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1432,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1433,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1434,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1435,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1436,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 7,
      key: 1437,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 1438,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 1439,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 1440,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 4,
      key: 1441,
    },
    {
      Location: '1000 6th St',
      center: [37.8826301, -122.3026462],
      count: 1,
      key: 1442,
    },
    {
      Location: '1000 Sixth St',
      center: [37.8826301, -122.3026462],
      count: 1,
      key: 1443,
    },
    {
      Location: '1005 6TH',
      center: [37.8827186, -122.3021147],
      count: 1,
      key: 1444,
    },
    {
      Location: '1005 Sixth St',
      center: [37.8827186, -122.3021147],
      count: 1,
      key: 1445,
    },
    {
      Location: '1020 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 1446,
    },
    {
      Location: '1070 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 1447,
    },
    {
      Location: '1110 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 2,
      key: 1448,
    },
    {
      Location: '1110 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 2,
      key: 1449,
    },
    {
      Location: '1123 Jackson St',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 1450,
    },
    {
      Location: '1301 S. 46th St',
      center: [37.9122458, -122.3338722],
      count: 2,
      key: 1451,
    },
    {
      Location: '1301 S. 46th St',
      center: [37.9122458, -122.3338722],
      count: 2,
      key: 1452,
    },
    {
      Location: '1601 Allston Wy',
      center: [37.8682939, -122.2785699],
      count: 1,
      key: 1453,
    },
    {
      Location: '1893 Le Roy Av',
      center: [37.8754174, -122.2581251],
      count: 2,
      key: 1454,
    },
    {
      Location: '1893 Le Roy Av',
      center: [37.8754174, -122.2581251],
      count: 2,
      key: 1455,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 1,
      key: 1456,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 5,
      key: 1457,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 5,
      key: 1458,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 5,
      key: 1459,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 5,
      key: 1460,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 5,
      key: 1461,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1462,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1463,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1464,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1465,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1466,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1467,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 7,
      key: 1468,
    },
    {
      Location: '2195 Hearst Av',
      center: [37.8743927, -122.2668799],
      count: 1,
      key: 1469,
    },
    {
      Location: '2199 Addison St',
      center: [37.8718509, -122.2665235],
      count: 1,
      key: 1470,
    },
    {
      Location: '2214 Bancroft Wy',
      center: [37.8678762, -122.2645482],
      count: 1,
      key: 1471,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1472,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1473,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1474,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1475,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1476,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1477,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1478,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1479,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1480,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 10,
      key: 1481,
    },
    {
      Location: '2223 Fulton St',
      center: [37.8688308, -122.2654656],
      count: 1,
      key: 1482,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1483,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1484,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1485,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1486,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1487,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1488,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1489,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 8,
      key: 1490,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1491,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1492,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1493,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1494,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1495,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1496,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1497,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1498,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1499,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1500,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1501,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1502,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1503,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1504,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1505,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1506,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1507,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1508,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1509,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1510,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1511,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1512,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1513,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1514,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1515,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1516,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1517,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1518,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1519,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1520,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1521,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 32,
      key: 1522,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 1,
      key: 1523,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1524,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1525,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1526,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1527,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1528,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1529,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1530,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1531,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1532,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1533,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1534,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1535,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1536,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1537,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1538,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1539,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 17,
      key: 1540,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 2,
      key: 1541,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 2,
      key: 1542,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 2,
      key: 1543,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 2,
      key: 1544,
    },
    {
      Location: '2441 Haste St',
      center: [37.86618139999999, -122.259141],
      count: 2,
      key: 1545,
    },
    {
      Location: '2441 Haste St',
      center: [37.86618139999999, -122.259141],
      count: 2,
      key: 1546,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 2,
      key: 1547,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 2,
      key: 1548,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 1549,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 1550,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1551,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1552,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1553,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1554,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1555,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1556,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1557,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1558,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1559,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1560,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 11,
      key: 1561,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1562,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1563,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1564,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1565,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1566,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1567,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1568,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1569,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1570,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1571,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1572,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1573,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1574,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1575,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1576,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1577,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 17,
      key: 1578,
    },
    {
      Location: '2610 Channing Wy',
      center: [37.8670799, -122.2556761],
      count: 1,
      key: 1579,
    },
    {
      Location: '2645 Haste St',
      center: [37.8669775, -122.2549008],
      count: 1,
      key: 1580,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1581,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1582,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1583,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1584,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1585,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1586,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1587,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1588,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1589,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1590,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1591,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1592,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1593,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1594,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1595,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1596,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1597,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1598,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1599,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 20,
      key: 1600,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1601,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1602,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1603,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1604,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1605,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1606,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1607,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1608,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1609,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1610,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1611,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1612,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1613,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1614,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1615,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1616,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1617,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1618,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1619,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1620,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1621,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1622,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1623,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1624,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1625,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1626,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1627,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1628,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1629,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1630,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1631,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1632,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 33,
      key: 1633,
    },
    {
      Location: '2684 Ridge Rd',
      center: [37.8762206, -122.2571975],
      count: 1,
      key: 1634,
    },
    {
      Location: '300 Gooding Wy',
      center: [37.885189, -122.302004],
      count: 1,
      key: 1635,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 3,
      key: 1636,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 3,
      key: 1637,
    },
    {
      Location: '335 Ohlone Av',
      center: [37.8849203, -122.3051266],
      count: 3,
      key: 1638,
    },
    {
      Location: '3800 San Pablo Av',
      center: [37.8291644, -122.2788319],
      count: 1,
      key: 1639,
    },
    {
      Location: '400 Ohlone Av',
      center: [37.88462020000001, -122.3042851],
      count: 1,
      key: 1640,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 4,
      key: 1641,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 4,
      key: 1642,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 4,
      key: 1643,
    },
    {
      Location: '415 Kula Gulf Wy',
      center: [37.8844418, -122.3035321],
      count: 4,
      key: 1644,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 1645,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 1646,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 1647,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 4,
      key: 1648,
    },
    {
      Location: '425 Liberty Ship Wy',
      center: [37.8843463, -122.3043294],
      count: 2,
      key: 1649,
    },
    {
      Location: '425 Liberty Ship Wy',
      center: [37.8843463, -122.3043294],
      count: 2,
      key: 1650,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 1651,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 1652,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 3,
      key: 1653,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 3,
      key: 1654,
    },
    {
      Location: '485 Ohlone Av',
      center: [37.8850123, -122.3044622],
      count: 3,
      key: 1655,
    },
    {
      Location: '515 West End Wy',
      center: [37.8840618, -122.3047723],
      count: 2,
      key: 1656,
    },
    {
      Location: '515 West End Wy',
      center: [37.8840618, -122.3047723],
      count: 2,
      key: 1657,
    },
    {
      Location: '525 Red Oak Av',
      center: [37.8831357, -122.3032233],
      count: 2,
      key: 1658,
    },
    {
      Location: '525 Red Oak Av',
      center: [37.8831357, -122.3032233],
      count: 2,
      key: 1659,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 1660,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 1661,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 1662,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 1663,
    },
    {
      Location: '530 Kinkead Wy',
      center: [37.8844287, -122.3030892],
      count: 5,
      key: 1664,
    },
    {
      Location: '540 Red Oak Av',
      center: [37.8827229, -122.3031281],
      count: 1,
      key: 1665,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 3,
      key: 1666,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 3,
      key: 1667,
    },
    {
      Location: '555 Ohlone Av',
      center: [37.8851586, -122.3036207],
      count: 3,
      key: 1668,
    },
    {
      Location: '600 RED OAK',
      center: [37.8820656, -122.2817154],
      count: 1,
      key: 1669,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 3,
      key: 1670,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 3,
      key: 1671,
    },
    {
      Location: '605 Ohlone Av',
      center: [37.8853413, -122.3027712],
      count: 3,
      key: 1672,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 3,
      key: 1673,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 3,
      key: 1674,
    },
    {
      Location: '625 West End Wy',
      center: [37.8837913, -122.3046837],
      count: 3,
      key: 1675,
    },
    {
      Location: '660 Kinkead Wy',
      center: [37.8839623, -122.302912],
      count: 2,
      key: 1676,
    },
    {
      Location: '660 Kinkead Wy',
      center: [37.8839623, -122.302912],
      count: 2,
      key: 1677,
    },
    {
      Location: '670 Kula Gulf Wy',
      center: [37.8839122, -122.3038643],
      count: 2,
      key: 1678,
    },
    {
      Location: '670 Kula Gulf Wy',
      center: [37.8839122, -122.3038643],
      count: 2,
      key: 1679,
    },
    {
      Location: '675 Kula Gulf Wy',
      center: [37.8840143, -122.3032885],
      count: 1,
      key: 1680,
    },
    {
      Location: '685 Liberty Ship Wy',
      center: [37.8836726, -122.3041747],
      count: 1,
      key: 1681,
    },
    {
      Location: '730 Kinkead Wy',
      center: [37.8836918, -122.3028234],
      count: 2,
      key: 1682,
    },
    {
      Location: '730 Kinkead Wy',
      center: [37.8836918, -122.3028234],
      count: 2,
      key: 1683,
    },
    {
      Location: '735 Gooding Wy',
      center: [37.8841952, -122.3012486],
      count: 1,
      key: 1684,
    },
    {
      Location: '755 Ohlone Av',
      center: [37.8856183, -122.3021811],
      count: 1,
      key: 1685,
    },
    {
      Location: '805 Kinkead Wy',
      center: [37.8837672, -122.3018489],
      count: 2,
      key: 1686,
    },
    {
      Location: '805 Kinkead Wy',
      center: [37.8837672, -122.3018489],
      count: 2,
      key: 1687,
    },
    {
      Location: '865 Kinkead Wy',
      center: [37.8835253, -122.3021704],
      count: 2,
      key: 1688,
    },
    {
      Location: '865 Kinkead Wy',
      center: [37.8835253, -122.3021704],
      count: 2,
      key: 1689,
    },
    {
      Location: '945 Ohlone Av',
      center: [37.8856374, -122.3010868],
      count: 1,
      key: 1690,
    },
    {
      Location: '980 Ohlone Av',
      center: [37.8855064, -122.300701],
      count: 1,
      key: 1691,
    },
    {
      Location: 'KULA GULF/RED OAK,',
      center: [37.8841356, -122.3036352],
      count: 1,
      key: 1692,
    },
    {
      Location: 'Moffitt Library,',
      center: [37.8725327, -122.2608366],
      count: 1,
      key: 1693,
    },
    {
      Location: 'Ohlone Av & Gooding Wy',
      center: [37.8851243, -122.3030119],
      count: 1,
      key: 1694,
    },
    {
      Location: 'Shattuck Av & Hearst Av',
      center: [37.873882, -122.268585],
      count: 1,
      key: 1695,
    },
    {
      Location: 'UVA-125,   UVA 755',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 1696,
    },
    {
      Location: 'Uva-112,    305',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 1697,
    },
    {
      Location: 'Uva-153,   Uva 202',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 1698,
    },
    {
      Location: 'Uva-169,   Uva 203',
      center: [36.6188397, -119.4898496],
      count: 1,
      key: 1699,
    }],
    'E-Bikes': [{
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 1700,
    },
    {
      Location: 'Bancroft Library',
      center: [37.872222, -122.2591277],
      count: 2,
      key: 1701,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 1702,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1703,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1704,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1705,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1706,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1707,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1708,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 7,
      key: 1709,
    },
    {
      Location: 'Bechtel Center',
      center: [37.8701625, -122.2692742],
      count: 1,
      key: 1710,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 1,
      key: 1711,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 1,
      key: 1712,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 2,
      key: 1713,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 2,
      key: 1714,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 1715,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 2,
      key: 1716,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1717,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1718,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1719,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 4,
      key: 1720,
    },
    {
      Location: 'Claremont Fire Tr',
      center: [37.871574, -122.2241913],
      count: 1,
      key: 1721,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 3,
      key: 1722,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 3,
      key: 1723,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 3,
      key: 1724,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 2,
      key: 1725,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 2,
      key: 1726,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1727,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1728,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1729,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1730,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1731,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1732,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1733,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1734,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1735,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1736,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1737,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1738,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1739,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 14,
      key: 1740,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 1,
      key: 1741,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1742,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1743,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1744,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1745,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1746,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1747,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1748,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1749,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1750,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1751,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1752,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1753,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1754,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1755,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1756,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 16,
      key: 1757,
    },
    {
      Location: 'Foothill-2',
      center: [37.8743687, -122.3044494],
      count: 1,
      key: 1758,
    },
    {
      Location: 'Gilman Hall',
      center: [37.8726066, -122.2562309],
      count: 1,
      key: 1759,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 1,
      key: 1760,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 1,
      key: 1761,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1762,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1763,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1764,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 4,
      key: 1765,
    },
    {
      Location: 'I House Lot',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 1766,
    },
    {
      Location: 'Kroeber Pz',
      center: [37.8693333, -122.2551512],
      count: 1,
      key: 1767,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 1,
      key: 1768,
    },
    {
      Location: 'Law Building Lot',
      center: [37.8699767, -122.2532914],
      count: 1,
      key: 1769,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 1770,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 2,
      key: 1771,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 1772,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 1,
      key: 1773,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 4,
      key: 1774,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 4,
      key: 1775,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 4,
      key: 1776,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 4,
      key: 1777,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 1,
      key: 1778,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1779,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1780,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1781,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1782,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1783,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1784,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1785,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1786,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1787,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1788,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1789,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1790,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 13,
      key: 1791,
    },
    {
      Location: 'Moses Hall',
      center: [37.8710156, -122.2580873],
      count: 1,
      key: 1792,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 1793,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 2,
      key: 1794,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 1795,
    },
    {
      Location: 'Parking Lot,',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 1796,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 5,
      key: 1797,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 5,
      key: 1798,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 5,
      key: 1799,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 5,
      key: 1800,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 5,
      key: 1801,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 1802,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 1803,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 1,
      key: 1804,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 1,
      key: 1805,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 1806,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 1,
      key: 1807,
    },
    {
      Location: 'Starr East Asian Library',
      center: [37.8735757, -122.2599796],
      count: 1,
      key: 1808,
    },
    {
      Location: 'Stephens Hall',
      center: [37.8713614, -122.2575925],
      count: 1,
      key: 1809,
    },
    {
      Location: 'Tan Hall',
      center: [37.8732811, -122.256512],
      count: 1,
      key: 1810,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1811,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1812,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1813,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1814,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1815,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1816,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1817,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1818,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1819,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1820,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1821,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 12,
      key: 1822,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 1823,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 1824,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 1825,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 1826,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 1827,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 3,
      key: 1828,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 1829,
    },
    {
      Location: 'Zellerbach Hall',
      center: [37.86904570000001, -122.2606874],
      count: 1,
      key: 1830,
    },
    {
      Location: '1108 8th Street',
      center: [37.8824687, -122.3000361],
      count: 1,
      key: 1831,
    },
    {
      Location: '1674 Shattuck Av',
      center: [37.877045, -122.2692766],
      count: 1,
      key: 1832,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1833,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1834,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 3,
      key: 1835,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 1,
      key: 1836,
    },
    {
      Location: '2155 Center St',
      center: [37.8706773, -122.2662258],
      count: 1,
      key: 1837,
    },
    {
      Location: '2214 Bancroft Wy',
      center: [37.8678762, -122.2645482],
      count: 1,
      key: 1838,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 3,
      key: 1839,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 3,
      key: 1840,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 3,
      key: 1841,
    },
    {
      Location: '2227 Piedmont Av',
      center: [37.8711347, -122.2508543],
      count: 1,
      key: 1842,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 1,
      key: 1843,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1844,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1845,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1846,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1847,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1848,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1849,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1850,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1851,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1852,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1853,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1854,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1855,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1856,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1857,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1858,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1859,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1860,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1861,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1862,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1863,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 21,
      key: 1864,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 1865,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 1866,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 1867,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 4,
      key: 1868,
    },
    {
      Location: '2415 Dwight Wy',
      center: [37.8656129, -122.2606284],
      count: 1,
      key: 1869,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 2,
      key: 1870,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 2,
      key: 1871,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 1872,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 1873,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 1874,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 1875,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 2,
      key: 1876,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 2,
      key: 1877,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 1878,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 2,
      key: 1879,
    },
    {
      Location: '2610 Channing Wy',
      center: [37.8670799, -122.2556761],
      count: 1,
      key: 1880,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 1,
      key: 1881,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 1882,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 1883,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 3,
      key: 1884,
    },
    {
      Location: '405 Red Oak Ave',
      center: [37.8833256, -122.3040229],
      count: 1,
      key: 1885,
    },
    {
      Location: '420 Kula Gulf Wy',
      center: [37.8842588, -122.3038864],
      count: 1,
      key: 1886,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 1887,
    },
    {
      Location: '435 Gooding Wy',
      center: [37.8851852, -122.3011644],
      count: 2,
      key: 1888,
    },
    {
      Location: '5325 Broder Blvd',
      center: [37.7182246, -121.8882794],
      count: 1,
      key: 1889,
    },
    {
      Location: '580 Ohlone Av',
      center: [37.8848291, -122.3034214],
      count: 1,
      key: 1890,
    },
    {
      Location: '755 Ohlone Av',
      center: [37.8856183, -122.3021811],
      count: 1,
      key: 1891,
    },
    {
      Location: '945 Ohlone Av',
      center: [37.8856374, -122.3010868],
      count: 1,
      key: 1892,
    },
    {
      Location: 'BARKER HALL',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 1893,
    },
    {
      Location: 'Harrison St 5TH STREET',
      center: [37.8809238, -122.3030285],
      count: 1,
      key: 1894,
    }],
    'E-Scooters': [{
      Location: '',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 1895,
    },
    {
      Location: '',
      center: [37.8715226, -122.273042],
      count: 2,
      key: 1896,
    },
    {
      Location: 'PPHCD',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 1897,
    },
    {
      Location: 'Southwest Corner Bicycle Racks',
      center: [37.8715226, -122.273042],
      count: 1,
      key: 1898,
    },
    {
      Location: 'Bancroft Wy',
      center: [37.8666995, -122.2747672],
      count: 1,
      key: 1899,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 4,
      key: 1900,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 4,
      key: 1901,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 4,
      key: 1902,
    },
    {
      Location: 'Barker Hall',
      center: [37.8739287, -122.2654702],
      count: 4,
      key: 1903,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1904,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1905,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1906,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1907,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1908,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1909,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1910,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1911,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1912,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1913,
    },
    {
      Location: 'Bauer Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 11,
      key: 1914,
    },
    {
      Location: 'Bechtel Center',
      center: [37.8701625, -122.2692742],
      count: 1,
      key: 1915,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1916,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1917,
    },
    {
      Location: 'Birge Hall',
      center: [37.8722322, -122.2571898],
      count: 3,
      key: 1918,
    },
    {
      Location: 'California Hall',
      center: [37.8718862, -122.2603499],
      count: 2,
      key: 1919,
    },
    {
      Location: 'California Hall',
      center: [37.8718862, -122.2603499],
      count: 2,
      key: 1920,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 2,
      key: 1921,
    },
    {
      Location: 'Campbell Hall',
      center: [37.8731446, -122.2571084],
      count: 2,
      key: 1922,
    },
    {
      Location: 'Campus (Unspecified Campus Location)',
      center: [37.8843444, -122.2524965],
      count: 1,
      key: 1923,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1924,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1925,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1926,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1927,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1928,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1929,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1930,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1931,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1932,
    },
    {
      Location: 'Cesar Chavez Center',
      center: [37.8695337, -122.2603326],
      count: 10,
      key: 1933,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1934,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1935,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1936,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1937,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1938,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1939,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1940,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1941,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1942,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1943,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1944,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1945,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1946,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1947,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1948,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1949,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1950,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1951,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1952,
    },
    {
      Location: 'Cheit Hall',
      center: [37.8716852, -122.254339],
      count: 20,
      key: 1953,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1954,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1955,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1956,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1957,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1958,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1959,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1960,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1961,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1962,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1963,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1964,
    },
    {
      Location: 'Chou Hall',
      center: [37.8722997, -122.2545436],
      count: 12,
      key: 1965,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1966,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1967,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1968,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1969,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1970,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1971,
    },
    {
      Location: 'Cory Hall',
      center: [37.8750364, -122.2573242],
      count: 7,
      key: 1972,
    },
    {
      Location: 'Cyclotron Rd',
      center: [37.8746504, -122.2521967],
      count: 1,
      key: 1973,
    },
    {
      Location: 'Davis Hall',
      center: [37.8745656, -122.2580841],
      count: 1,
      key: 1974,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 3,
      key: 1975,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 3,
      key: 1976,
    },
    {
      Location: 'Doe Library',
      center: [37.8722068, -122.2592367],
      count: 3,
      key: 1977,
    },
    {
      Location: 'Durant Hall',
      center: [37.8712498, -122.2600955],
      count: 1,
      key: 1978,
    },
    {
      Location: 'Dwinelle Annex',
      center: [37.8703395, -122.2612068],
      count: 1,
      key: 1979,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1980,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1981,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1982,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1983,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1984,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1985,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1986,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1987,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1988,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1989,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1990,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1991,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1992,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1993,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1994,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1995,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1996,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1997,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1998,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 1999,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2000,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2001,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2002,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2003,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2004,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2005,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2006,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2007,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2008,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2009,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2010,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2011,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2012,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2013,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2014,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2015,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2016,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2017,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2018,
    },
    {
      Location: 'Dwinelle Hall',
      center: [37.87053179999999, -122.2606042],
      count: 40,
      key: 2019,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 4,
      key: 2020,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 4,
      key: 2021,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 4,
      key: 2022,
    },
    {
      Location: 'Dwinelle Plaza',
      center: [37.8710795, -122.2600849],
      count: 4,
      key: 2023,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2024,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2025,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2026,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2027,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2028,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2029,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2030,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2031,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2032,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2033,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2034,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2035,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2036,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2037,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2038,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2039,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2040,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2041,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2042,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2043,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2044,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2045,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2046,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2047,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2048,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2049,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2050,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2051,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2052,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2053,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2054,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2055,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2056,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2057,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2058,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2059,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2060,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2061,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2062,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2063,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2064,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2065,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2066,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2067,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2068,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2069,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2070,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2071,
    },
    {
      Location: 'Evans Hall',
      center: [37.8736125, -122.2575941],
      count: 49,
      key: 2072,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2073,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2074,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2075,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2076,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2077,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2078,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2079,
    },
    {
      Location: 'Golden Bear Cafe',
      center: [37.8698436, -122.2596451],
      count: 8,
      key: 2080,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2081,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2082,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2083,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2084,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2085,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2086,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2087,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2088,
    },
    {
      Location: 'Haas Pavilion',
      center: [37.8694051, -122.2621795],
      count: 9,
      key: 2089,
    },
    {
      Location: 'Haviland Hall',
      center: [37.8737118, -122.2610484],
      count: 1,
      key: 2090,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 5,
      key: 2091,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 5,
      key: 2092,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 5,
      key: 2093,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 5,
      key: 2094,
    },
    {
      Location: 'Hearst Mining Building',
      center: [37.8741545, -122.2571922],
      count: 5,
      key: 2095,
    },
    {
      Location: 'Hertz Hall',
      center: [37.8710584, -122.2557289],
      count: 1,
      key: 2096,
    },
    {
      Location: 'Hesse Hall',
      center: [37.8743128, -122.2593508],
      count: 1,
      key: 2097,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 2098,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 2099,
    },
    {
      Location: 'Hildebrand Hall',
      center: [37.8725916, -122.2553429],
      count: 3,
      key: 2100,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 2,
      key: 2101,
    },
    {
      Location: 'Latimer Hall',
      center: [37.8731064, -122.2559915],
      count: 2,
      key: 2102,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 2,
      key: 2103,
    },
    {
      Location: 'Law Building',
      center: [37.8699767, -122.2532914],
      count: 2,
      key: 2104,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2105,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2106,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2107,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2108,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2109,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2110,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2111,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2112,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2113,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2114,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2115,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2116,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2117,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2118,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2119,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2120,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2121,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2122,
    },
    {
      Location: 'Li Ka Shing Center',
      center: [37.8726214, -122.26528],
      count: 19,
      key: 2123,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 2,
      key: 2124,
    },
    {
      Location: 'Lower Sproul Plaza',
      center: [37.8691667, -122.2602361],
      count: 2,
      key: 2125,
    },
    {
      Location: 'Lower Sproul Pz',
      center: [37.8691667, -122.2602361],
      count: 1,
      key: 2126,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 2127,
    },
    {
      Location: 'McCone Hall',
      center: [37.8740817, -122.2596788],
      count: 2,
      key: 2128,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2129,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2130,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2131,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2132,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2133,
    },
    {
      Location: 'Memorial Stadium',
      center: [37.8706571, -122.2507783],
      count: 6,
      key: 2134,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 3,
      key: 2135,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 3,
      key: 2136,
    },
    {
      Location: 'Minor Hall',
      center: [37.8714283, -122.2547013],
      count: 3,
      key: 2137,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2138,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2139,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2140,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2141,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2142,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2143,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2144,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2145,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2146,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2147,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2148,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2149,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2150,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2151,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2152,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2153,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2154,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2155,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2156,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2157,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2158,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2159,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2160,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2161,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2162,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2163,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2164,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2165,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2166,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2167,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2168,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2169,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2170,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2171,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2172,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2173,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2174,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2175,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2176,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2177,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2178,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2179,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2180,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2181,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2182,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2183,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2184,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2185,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2186,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2187,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2188,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2189,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2190,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2191,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2192,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2193,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2194,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2195,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2196,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2197,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2198,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2199,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2200,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2201,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2202,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2203,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2204,
    },
    {
      Location: 'Moffitt Library',
      center: [37.8725327, -122.2608366],
      count: 68,
      key: 2205,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 5,
      key: 2206,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 5,
      key: 2207,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 5,
      key: 2208,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 5,
      key: 2209,
    },
    {
      Location: 'Morrison Hall',
      center: [37.8708467, -122.2564972],
      count: 5,
      key: 2210,
    },
    {
      Location: 'Moses Hall',
      center: [37.8710156, -122.2580873],
      count: 1,
      key: 2211,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 2212,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 2213,
    },
    {
      Location: 'Mulford Hall',
      center: [37.8725976, -122.2644263],
      count: 3,
      key: 2214,
    },
    {
      Location: 'North Sproul Lot',
      center: [37.8703147, -122.2589821],
      count: 1,
      key: 2215,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2216,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2217,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2218,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2219,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2220,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2221,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2222,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2223,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2224,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2225,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2226,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2227,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2228,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2229,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2230,
    },
    {
      Location: 'Physics Building',
      center: [37.8715226, -122.273042],
      count: 16,
      key: 2231,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2232,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2233,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2234,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2235,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2236,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2237,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2238,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2239,
    },
    {
      Location: 'Pimentel Hall',
      center: [37.8734123, -122.2560176],
      count: 9,
      key: 2240,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 2241,
    },
    {
      Location: 'Sather Gate',
      center: [37.8702589, -122.2595146],
      count: 2,
      key: 2242,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 2,
      key: 2243,
    },
    {
      Location: 'Sather Tower',
      center: [37.87206159999999, -122.2578123],
      count: 2,
      key: 2244,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2245,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2246,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2247,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2248,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2249,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2250,
    },
    {
      Location: 'Social Sciences Building',
      center: [37.8700546, -122.25799],
      count: 7,
      key: 2251,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 2,
      key: 2252,
    },
    {
      Location: 'South Hall',
      center: [37.8712935, -122.2585081],
      count: 2,
      key: 2253,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2254,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2255,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2256,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2257,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2258,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2259,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2260,
    },
    {
      Location: 'Spieker Plaza',
      center: [37.8699765, -122.2618077],
      count: 8,
      key: 2261,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 5,
      key: 2262,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 5,
      key: 2263,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 5,
      key: 2264,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 5,
      key: 2265,
    },
    {
      Location: 'Sproul Hall',
      center: [37.8692363, -122.2587453],
      count: 5,
      key: 2266,
    },
    {
      Location: 'Stanley Hall',
      center: [37.87385099999999, -122.2563984],
      count: 1,
      key: 2267,
    },
    {
      Location: 'Stern Hall',
      center: [37.8750175, -122.2555009],
      count: 1,
      key: 2268,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 5,
      key: 2269,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 5,
      key: 2270,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 5,
      key: 2271,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 5,
      key: 2272,
    },
    {
      Location: 'Upper Sproul Plaza',
      center: [37.8695385, -122.2593363],
      count: 5,
      key: 2273,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2274,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2275,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2276,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2277,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2278,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2279,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2280,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2281,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2282,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2283,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2284,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2285,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2286,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2287,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2288,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2289,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2290,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2291,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2292,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2293,
    },
    {
      Location: 'Valley Life Science Building',
      center: [37.8714023, -122.2622038],
      count: 21,
      key: 2294,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 2295,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 2296,
    },
    {
      Location: 'Weill Hall',
      center: [37.870932, -122.262988],
      count: 3,
      key: 2297,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2298,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2299,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2300,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2301,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2302,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2303,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2304,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2305,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2306,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2307,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2308,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2309,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2310,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2311,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2312,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2313,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2314,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2315,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2316,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2317,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2318,
    },
    {
      Location: 'Wheeler Hall',
      center: [37.8713136, -122.2591478],
      count: 22,
      key: 2319,
    },
    {
      Location: 'Wurster Hall',
      center: [37.8707352, -122.2548935],
      count: 1,
      key: 2320,
    },
    {
      Location: 'Zellerbach Hall',
      center: [37.86904570000001, -122.2606874],
      count: 1,
      key: 2321,
    },
    {
      Location: '1070 Jackson St',
      center: [38.3060932, -122.2910994],
      count: 1,
      key: 2322,
    },
    {
      Location: '1898 Le Roy Av',
      center: [37.87533519999999, -122.2583139],
      count: 2,
      key: 2323,
    },
    {
      Location: '1898 Le Roy Av',
      center: [37.87533519999999, -122.2583139],
      count: 2,
      key: 2324,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 2325,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 2326,
    },
    {
      Location: '1995 University Av',
      center: [37.872094, -122.2712864],
      count: 3,
      key: 2327,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2328,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2329,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2330,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2331,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2332,
    },
    {
      Location: '2121 Berkeley Wy',
      center: [37.873428, -122.2675339],
      count: 6,
      key: 2333,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 3,
      key: 2334,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 3,
      key: 2335,
    },
    {
      Location: '2151 Berkeley Wy',
      center: [37.873844, -122.2669395],
      count: 3,
      key: 2336,
    },
    {
      Location: '2195 Hearst Av',
      center: [37.8743927, -122.2668799],
      count: 1,
      key: 2337,
    },
    {
      Location: '2200 Gayley Rd',
      center: [37.8722334, -122.2537191],
      count: 1,
      key: 2338,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2339,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2340,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2341,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2342,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2343,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2344,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2345,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2346,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2347,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2348,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2349,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2350,
    },
    {
      Location: '2220 Piedmont Av',
      center: [37.8715011, -122.2538019],
      count: 13,
      key: 2351,
    },
    {
      Location: '2222 Bancroft Wy',
      center: [37.8676679, -122.2642858],
      count: 2,
      key: 2352,
    },
    {
      Location: '2222 Bancroft Wy',
      center: [37.8676679, -122.2642858],
      count: 2,
      key: 2353,
    },
    {
      Location: '2223 Fulton St',
      center: [37.8688308, -122.2654656],
      count: 1,
      key: 2354,
    },
    {
      Location: '2225 Piedmont Av',
      center: [37.87103949999999, -122.2526357],
      count: 1,
      key: 2355,
    },
    {
      Location: '2227 Piedmont Av',
      center: [37.8711347, -122.2508543],
      count: 1,
      key: 2356,
    },
    {
      Location: '2240 Piedmont Av',
      center: [37.8703966, -122.2528792],
      count: 2,
      key: 2357,
    },
    {
      Location: '2240 Piedmont Av',
      center: [37.8703966, -122.2528792],
      count: 2,
      key: 2358,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 2,
      key: 2359,
    },
    {
      Location: '2299 Piedmont Av',
      center: [37.8696559, -122.2514304],
      count: 2,
      key: 2360,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2361,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2362,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2363,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2364,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2365,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2366,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2367,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2368,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2369,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2370,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2371,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2372,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2373,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2374,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2375,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2376,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2377,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2378,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2379,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2380,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2381,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2382,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2383,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2384,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2385,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2386,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2387,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2388,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2389,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2390,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2391,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2392,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2393,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2394,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2395,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2396,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2397,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2398,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2399,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2400,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2401,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2402,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2403,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2404,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2405,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2406,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2407,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2408,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2409,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2410,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2411,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2412,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2413,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2414,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2415,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2416,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2417,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2418,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2419,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2420,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2421,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2422,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2423,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2424,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2425,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2426,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2427,
    },
    {
      Location: '2301 Bancroft Wy',
      center: [37.8684484, -122.2624696],
      count: 68,
      key: 2428,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 2,
      key: 2429,
    },
    {
      Location: '2309 Haste St',
      center: [37.8656874, -122.2628852],
      count: 2,
      key: 2430,
    },
    {
      Location: '2369 Telegraph Av',
      center: [37.8674335, -122.2586978],
      count: 1,
      key: 2431,
    },
    {
      Location: '2400 Bancroft Wy',
      center: [37.8683734, -122.261079],
      count: 1,
      key: 2432,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2433,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2434,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2435,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2436,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2437,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2438,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2439,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2440,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2441,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2442,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2443,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2444,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2445,
    },
    {
      Location: '2400 Durant Av',
      center: [37.8671726, -122.2603606],
      count: 14,
      key: 2446,
    },
    {
      Location: '2401 Durant Av',
      center: [37.8676699, -122.2611691],
      count: 2,
      key: 2447,
    },
    {
      Location: '2401 Durant Av',
      center: [37.8676699, -122.2611691],
      count: 2,
      key: 2448,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2449,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2450,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2451,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2452,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2453,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2454,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2455,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2456,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2457,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2458,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2459,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2460,
    },
    {
      Location: '2415 Bowditch St',
      center: [37.8669751, -122.2563026],
      count: 13,
      key: 2461,
    },
    {
      Location: '2424 Haste St',
      center: [37.865682, -122.2597392],
      count: 1,
      key: 2462,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 2463,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 2464,
    },
    {
      Location: '2465 Bancroft Wy',
      center: [37.8687522, -122.2604703],
      count: 3,
      key: 2465,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 2466,
    },
    {
      Location: '2495 Bancroft Wy',
      center: [37.8689709, -122.259554],
      count: 2,
      key: 2467,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 2468,
    },
    {
      Location: '2520 Channing Wy',
      center: [37.8667623, -122.2576087],
      count: 2,
      key: 2469,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 3,
      key: 2470,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 3,
      key: 2471,
    },
    {
      Location: '2521 Hearst Av',
      center: [37.8756626, -122.2592805],
      count: 3,
      key: 2472,
    },
    {
      Location: '2600 Ridge Rd',
      center: [37.8761356, -122.2579888],
      count: 2,
      key: 2473,
    },
    {
      Location: '2600 Ridge Rd',
      center: [37.8761356, -122.2579888],
      count: 2,
      key: 2474,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2475,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2476,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2477,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2478,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2479,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2480,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2481,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2482,
    },
    {
      Location: '2601 Warring St',
      center: [37.8638798, -122.2493001],
      count: 9,
      key: 2483,
    },
    {
      Location: '2607 Hearst Av',
      center: [37.8757268, -122.2578584],
      count: 1,
      key: 2484,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 2485,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 2486,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 2487,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 2488,
    },
    {
      Location: '2650 Durant Av',
      center: [37.8681223, -122.2550086],
      count: 5,
      key: 2489,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 4,
      key: 2490,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 4,
      key: 2491,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 4,
      key: 2492,
    },
    {
      Location: '2650 Haste St',
      center: [37.8664947, -122.2543359],
      count: 4,
      key: 2493,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 2494,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 2495,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 2496,
    },
    {
      Location: '2700 Hearst Av',
      center: [37.87538, -122.2561211],
      count: 4,
      key: 2497,
    },
    {
      Location: '3100 Adeline St',
      center: [37.85267899999999, -122.2698196],
      count: 1,
      key: 2498,
    },
    {
      Location: '400 Ohlone Av',
      center: [37.88462020000001, -122.3042851],
      count: 1,
      key: 2499,
    },
    {
      Location: '5325 Broder Blvd',
      center: [37.7182246, -121.8882794],
      count: 1,
      key: 2500,
    },
    {
      Location: '685 Libertyship Wy',
      center: [37.8836726, -122.3041747],
      count: 1,
      key: 2501,
    },
    {
      Location: 'BARKER HALL',
      center: [37.8739287, -122.2654702],
      count: 1,
      key: 2502,
    },
    {
      Location: 'Bancroft Wy Dana St',
      center: [37.8685055, -122.2617699],
      count: 1,
      key: 2503,
    },
    {
      Location: 'Bowditch St Durant Av',
      center: [37.8681013, -122.256738],
      count: 1,
      key: 2504,
    },
    {
      Location: 'Campanile Wy Dwinelle Path',
      center: [37.8714314, -122.2605093],
      count: 1,
      key: 2505,
    },
    {
      Location: 'Claremont Av Russell St',
      center: [37.8590106, -122.2445519],
      count: 1,
      key: 2506,
    },
    {
      Location: 'Harrison St 5TH STREET',
      center: [37.8809238, -122.3030285],
      count: 1,
      key: 2507,
    },
    {
      Location: 'Hearst Av Spruce St',
      center: [37.8741496, -122.2655683],
      count: 1,
      key: 2508,
    },
    {
      Location: 'Piedmont Av',
      center: [37.8640777, -122.2514871],
      count: 2,
      key: 2509,
    },
    {
      Location: 'Piedmont Av',
      center: [37.8640777, -122.2514871],
      count: 2,
      key: 2510,
    },
    {
      Location: 'Piedmont Av Durant Av',
      center: [37.8686768, -122.2522753],
      count: 1,
      key: 2511,
    },
    {
      Location: 'SPIEKER PLAZA',
      center: [37.8699765, -122.2618077],
      count: 1,
      key: 2512,
    },
    {
      Location: 'Shattuck Av Bancroft Wy',
      center: [37.8676154, -122.2677181],
      count: 1,
      key: 2513,
    },
    {
      Location: 'Sports Ln South Street',
      center: [37.8646472, -122.2469543],
      count: 1,
      key: 2514,
    },
    {
      Location: 'Telegraph Av Bancroft Wy',
      center: [37.8687232, -122.2592109],
      count: 1,
      key: 2515,
    },
    {
      Location: 'Telegraph Av Channing Wy',
      center: [37.8669249, -122.2588171],
      count: 1,
      key: 2516,
    },
    {
      Location: 'University Av Oxford Ln',
      center: [37.8723917, -122.2661629],
      count: 1,
      key: 2517,
    }],
  },
};
